<template>
  <div class="duplicate-group-card-item pt-4">
    <div class="duplicate-breakdown-container">
      <duplicate-breakdown
        class="px-6"
        :index="index"
        :main-copy="mainCopy.publication"
        :other-copy="otherCopy.publication"
        :show-all-fields="showAllFields"
      />
      <div class="show-all-fields-button-container px-6">
        <div></div>
        <div class="show-all-fields-button">
          <rounded-action-button
            height="30"
            @click="showAllFields = !showAllFields"
          >
            <span class="caption">{{ expandButtonLabel }}</span>
            <v-icon small>{{ expandButtonIcon }}</v-icon>
          </rounded-action-button>
        </div>
      </div>
    </div>
    <div>
      <v-divider />
      <duplicate-controls
        :reference="otherCopy"
        @mark-as-duplicate="$emit('mark-as-duplicate')"
        @mark-as-not-duplicate="$emit('mark-as-not-duplicate')"
      />
    </div>
  </div>
</template>

<script>
import RoundedActionButton from '@/components/Common/RoundedActionButton';
import DuplicateBreakdown from './DuplicateBreakdown';
import DuplicateControls from './DuplicateControls';
import { Reference } from '@/models';

export default {
  name: 'DuplicateGroupCardItem',
  components: {
    RoundedActionButton,
    DuplicateBreakdown,
    DuplicateControls,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    mainCopy: {
      type: Reference,
      required: true,
    },
    otherCopy: {
      type: Reference,
      required: true,
    },
  },
  emits: ['mark-as-duplicate', 'mark-as-not-duplicate'],
  data: () => ({ showAllFields: false }),
  computed: {
    expandButtonLabel() {
      return this.showAllFields
        ? 'Hide Matching Fields'
        : 'Show All Fields';
    },
    expandButtonIcon() {
      return this.showAllFields ? 'unfold_less' : 'unfold_more';
    },
  },
};
</script>

<style lang="scss" scoped>
.duplicate-group-card-item {
  display: grid;
  gap: 24px;
}
.duplicate-breakdown-container {
  // To assist positioning the "Show All Fields" button.
  position: relative;
}
.show-all-fields-button-container {
  // Make the button container the size of the parent.
  position: absolute;
  top: 0;
  right: 0;
  left: 0;

  // But a little extended height-wise to nudge the button beyond at the bottom.
  bottom: -15px;

  // Match the grid in the duplicate breakdown component.
  display: grid;
  grid-template-columns: 1fr 6fr;

  // Make the button take no pointer events.
  pointer-events: none;

  .show-all-fields-button {
    // Center and bottom-align the button in the container.
    display: flex;
    justify-content: center;
    align-items: flex-end;

    > * {
      // Make the button take pointer events.
      pointer-events: auto;
    }
  }
}
</style>
